<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" v-if="loanTypes.length">
				<span class="ml-2">فیلترها: </span>
				<v-btn-toggle v-model="loanTypeFilter" dense tile outlined color="purple" class="mr-2 flex-wrap">
					<v-btn v-for="loanType in loanTypes" :key="loanType.id" :value="loanType.id" small>
						{{ loanType.title }}
						<v-badge color="blue" :content="loanType.id === 0 ? items.length : items.filter(x => x.userLoanModel.loanModel.id == loanType.id).length || '0'" inline>
						</v-badge>
					</v-btn>
				</v-btn-toggle>
			</v-col>
			<v-col cols="12" v-if="agents.length">
				<span class="ml-2">فیلتر نماینده:</span>
				<v-btn-toggle v-model="agentFilter" dense tile outlined color="purple" class="mr-2 flex-wrap">
					<v-btn v-for="agent in agents" :key="agent.id" :value="agent.id" small>
						{{ agent.businessName }}
						<v-badge color="blue" :content="agent.id === 0 ? items.filter(x => x.userLoanModel.agentModel).length : `تعداد: ${items.filter(x => x.userLoanModel.agentModel && x.userLoanModel.agentModel.id == agent.id).length}, مجموع: ${String(items.filter(x => x.userLoanModel.agentModel && x.userLoanModel.agentModel.id == agent.id).reduce(function (a, b) { return a + b.userLoanModel.installment }, 0)).toPriceFormat()}` || '0'" inline>
						</v-badge>
					</v-btn>
				</v-btn-toggle>
			</v-col>
			<v-col cols="11">
				<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
			</v-col>
			<v-col cols="1">
				<export-excel :items="items" :headers="headers" :fileName="excelFileName">
				</export-excel>
			</v-col>
			<v-col cols="12">
				<v-data-table :height="dataTableFixedHeight - 100" fixed-header :headers="headers" :loading="loading" :items="filteredItems" :items-per-page="500" :search="search" class="elevation-1">
					<template v-slot:item="row">
						<tr>
							<td @click="manageLoans(row.item)" style="cursor: pointer;">
								{{ row.item.userLoanModel.loanModel.title }}
								<div class="grey--text">کد: {{ row.item.userLoanModel.code }}</div>
								<div class="grey--text">قسط شماره: {{ row.item.installmentNumber }}</div>
							</td>
							<td @click="manageLoans(row.item)" style="cursor: pointer;">
								<div>{{ row.item.userLoanModel.memberModel.fullName }}</div>
								<div class="grey--text" v-if="row.item.userLoanModel.agentModel">
									نماینده: {{ row.item.userLoanModel.agentModel.businessName }}
								</div>
							</td>
							<td class="text-center">
								{{ row.item.userLoanModel.memberModel.mobile }}
							</td>
							<td class="text-center">
								{{
									`${row.item.targetMonth_Persian.year}/${row.item.targetMonth_Persian.month}/${row.item.targetMonth_Persian.day}`
								}}
							</td>
							<td class="text-center">
								{{ row.item.userLoanModel.installment.toString().toPriceFormat() }}
							</td>
							<td class="text-center">
								<div :class="row.item.delayDay > 0 ? 'red--text' : 'success--text'" v-if="row.item.delayDay != 0">
									<div style="white-space: nowrap;">{{ row.item.delayDay > 0 ? 'دیرکرد' : 'زودکرد' }}: {{
										Math.abs(row.item.delayDay) }} روز</div>
									<div v-if="row.item.delayPrice">{{ row.item.delayPrice.toString().toPriceFormat() }}</div>
								</div>
							</td>
							<td class="text-center">
								<app-sms-detail :data="row.item.appSmsList" :entityId="row.item.id" />
							</td>
							<td class="text-center">
								<v-btn class="mx-2" fab dark small color="secondary" @click="edit(row.item)">
									<v-icon dark>
										mdi-square-edit-outline
									</v-icon>
								</v-btn>
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
		<div class="d-flex" style="position: absolute;bottom: 0;left: 0;
    right: 0;
    font-size: 22px;
    background-color: rebeccapurple;
    color: #fff;
		justify-content: space-between;
    flex-wrap: wrap;">
			<div class="text-center px-3 py-3">
				خالص اقساط: {{ sum.toString().toPriceFormat() }}
			</div>
			<div class="text-center px-3 py-3">
				اقساط با احتساب دیرکرد: {{ sumByDelays.toString().toPriceFormat() }}
			</div>
		</div>
		<v-dialog v-model="dialogModifyLoanPayment" scrollable persistent max-width="900px">
			<v-card>
				<v-card-title>
					<div><span class="headline">ویرایش قسط</span></div>
					<v-spacer />
					<v-btn @click="dialogModifyLoanPayment = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-loan-payment ref="modifyLoanPayment" v-if="dialogModifyLoanPayment" :data="selectedLoanPayment" @callbck="callbck_loanPayment" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogLoansManager" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت وام</span></div>
					<v-spacer />
					<v-btn @click="dialogLoansManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<manage-loan ref="manageLoan" v-if="dialogLoansManager" :data="{ member: selectedMember }" />
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
	import ModifyLoanPayment from '@/views/admin/ModifyLoanPayment.vue'

	export default {
		name: 'OverDueInstallments',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'date-picker': VuePersianDatetimePicker,
			'modify-loan-payment': ModifyLoanPayment,
			'manage-loan': () => import('@/views/admin/ManageLoan.vue'),
			'app-sms-detail': () => import('@/components/AppSmsDetails.vue'),
		},
		data() {
			return {
				dialogLoansManager: false,
				dialogModifyLoanPayment: false,
				selectedMember: {},
				selectedLoanPayment: null,
				errorMessages: '',
				search: '',
				loading: false,
				sum: 0,
				sumByDelays: 0,
				headers: [
					{
						text: 'وام',
						align: 'start',
						sortable: true,
						value: 'userLoanModel.loanModel.title',
					}, {
						text: 'نام مشتری',
						align: 'start',
						sortable: true,
						value: 'userLoanModel.memberModel.fullName',
					}, {
						text: 'موبایل',
						align: 'center',
						sortable: true,
						value: 'userLoanModel.memberModel.mobile',
					}, {
						text: 'تاریخ سررسید',
						align: 'center',
						sortable: true,
						value: 'targetMonth_Persian',
						excel_value: 'targetMonth_Persian.date',
					}, {
						text: 'مبلغ',
						align: 'center',
						sortable: true,
						value: 'userLoanModel.installment',
					}, {
						text: 'دیرکرد',
						align: 'center',
						sortable: true,
						value: 'delayPrice',
						width: 100
					}, {
						text: 'پیامک ها',
						align: 'center',
						sortable: false,
						value: 'appSmsList',
					}, {
						text: 'ثبت پرداختی',
						align: 'center',
						sortable: false,
					},
				],
				items: [],
				loanTypes: [],
				agents: [],
				loanTypeFilter: 0,
				agentFilter: ''
			}
		},
		computed: {
			excelFileName() {
				let name = 'لیست اقساط معوق'
				// if (this.startDate)
				// 	name += ' از ' + this.startDate.toString().split('T')[0]
				// if (this.endDate)
				// 	name += ' تا ' + this.endDate.toString().split('T')[0]
				name += '.xls'
				return name
			},
			filteredItems() {
				if (!this.loanTypeFilter && !this.agentFilter)
					return this.items

				let clonedItems = []
				clonedItems.push(...this.items)

				if (this.loanTypeFilter)
					clonedItems = clonedItems.filter(x => this.loanTypeFilter.indexOf(x.userLoanModel.loanModel.id) > -1)

				if (this.agentFilter)
					clonedItems = clonedItems.filter(x => x.userLoanModel.agentModel && x.userLoanModel.agentModel.id == this.agentFilter)

				return clonedItems
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			edit(payment) {
				this.selectedLoanPayment = { id: payment.id, userLoanModel: payment.userLoanModel }
				this.dialogModifyLoanPayment = true
			},
			callbck_loanPayment(result) {
				this.dialogModifyLoanPayment = false
				if (result) {
					this.loadData()
					this.$emit('changed')
				}
			},
			loadData() {
				this.loading = true
				api.get('admin/report/OverDueInstallments', {})
					.then(
						response => {
							this.items = response.loanPayments
							this.sum = response.sum
							this.sumByDelays = response.sumByDelays
							this.loanTypes = Object.values(
								response.loanPayments.reduce((acc, obj) => ({ ...acc, [obj.userLoanModel.loanModel.id]: obj.userLoanModel.loanModel }), {})
							)
							if (this.loanTypes.length) {
								this.loanTypes.push({ id: 0, title: 'همه' })
							}
							this.agents = Object.values(
								response.loanPayments.filter(x => x.userLoanModel.agentModel).reduce((acc, obj) => ({ ...acc, [obj.userLoanModel.agentModel.id]: obj.userLoanModel.agentModel }), {})
							)
							if (this.agents.length) {
								this.agents.push({ id: 0, businessName: 'همه' })
							}
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			manageLoans(item) {
				this.selectedMember = {
					id: item.userLoanModel.memberModel.id,
					fullName: item.userLoanModel.memberModel.fullName,
					nationalCode: item.userLoanModel.memberModel.nationalCode,
					mobile: item.userLoanModel.memberModel.mobile,
					userName: item.userLoanModel.memberModel.userName
				}
				this.dialogLoansManager = true
			},
		},
	}
</script>
<style></style>
